import { NgIf } from '@angular/common';
import { Component, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { InlineSVGModule } from 'ng-inline-svg-2';
import { SortDirection, SortEvent } from '../common.types';

@Component({
  selector: 'app-sort-box',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './sort-box.component.html',
  standalone: true,
  imports: [
    InlineSVGModule,
    NgIf,
  ],
})
export class SortBoxComponent {
  @Input()
  public fieldName: string;

  @Input()
  public direction: SortDirection | null;

  @Input()
  public defaultDirection: SortDirection;

  @Output()
  public changeSort = new EventEmitter<SortEvent>();

  private readonly nextDirectionMap = {
    [SortDirection.ASC]: SortDirection.DESC,
    [SortDirection.DESC]: SortDirection.ASC
  };

  public get arrowIconPath(): string|null {
    switch (this.direction) {
    case SortDirection.ASC:
      return './assets/media/icons/duotune/arrows/arr073.svg';
    case SortDirection.DESC:
      return './assets/media/icons/duotune/arrows/arr072.svg'
    default:
      return null;
    }
  }

  public toggleSort() {
    let nextDirection: SortDirection;
    if (this.direction === null || this.direction === undefined) {
      nextDirection = this.defaultDirection;
    } else {
      nextDirection = this.nextDirectionMap[this.direction] || SortDirection.ASC;
    }
    this.changeSort.emit({
      name: this.fieldName,
      direction: nextDirection
    });
  }
}
